import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'lp2-mini-lesson-tile-complete',
  template: `
    <lp2-mini-lesson-info-banner
      [title]="'studybundle.lessons.completedUnitsTitle' | translate"
      [body]="'studybundle.lessons.completedUnitsDescription' | translate"
      iconSrc="/images/icon-completed-lessons.png"
      iconAlt="graduation cap"
    >
      <div
        class="info-banner-cta"
        [innerHTML]="'studybundle.lessons.goToUnitIndex' | translate: { here: 'activation.student_info.errors.phone_number.valid.here' | translate }"
      ></div>
    </lp2-mini-lesson-info-banner>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MiniLessonTileCompleteComponent {}



// WEBPACK FOOTER //
// ./ts/app/home/mini-lesson-section/mini-lesson-tile-complete/mini-lesson-tile-complete.component.ts